import { useState } from 'react';

import { useDucatClient } from '@/context/DucatClientCtx';
import { useNetwork } from '@/stores/useAppStore';

import { handleCookieConsentFromFirstWindow, handleCookieConsentFromSecondWindow, handleCookieConsentNotAllow } from './cookie.utils';

export const useCookiePolicy = (isCookieConsent: boolean | undefined, isPosthogIdentify: boolean | undefined) => {
  const selectedNetwork = useNetwork();
  const { walletAddress, walletType, pubkey: walletPubkey } = useDucatClient();

  const [isCookieConsentAllowed, setIsCookieConsentAllowed] = useState<boolean | undefined>(isCookieConsent);
  const [isPosthogIdentifyAllowed, setIsPosthogIdentifyAllowed] = useState<boolean | undefined>(isPosthogIdentify);

  const handleAllowFromFirstWindow = () => {
    setIsCookieConsentAllowed(true);
    setIsPosthogIdentifyAllowed(true);

    handleCookieConsentFromFirstWindow(walletAddress, walletPubkey, walletType, selectedNetwork);
  };

  const handleAllowFromSecondWindow = () => {
    handleCookieConsentFromSecondWindow();

    setIsCookieConsentAllowed(true);
    setIsPosthogIdentifyAllowed(false);
  };

  const handleNotAllow = () => {
    handleCookieConsentNotAllow();

    setIsPosthogIdentifyAllowed(false);
    setIsCookieConsentAllowed((prevState) => {
      if (prevState === undefined) {
        return false;
      }

      if (prevState === false) {
        globalThis.location.href = process.env.NEXT_PUBLIC_DUCAT_PAGE || 'https://ducatprotocol.com';

        return prevState;
      }

      return prevState;
    });
  };

  return {
    isCookieConsentAllowed,
    isPosthogIdentifyAllowed,
    setIsCookieConsentAllowed,
    setIsPosthogIdentifyAllowed,
    handleAllowFromSecondWindow,
    handleAllowFromFirstWindow,
    handleNotAllow,
  };
};
